// A '.tsx' file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React from 'react';
interface TreeProps extends React.PropsWithChildren<{}> {
    parentNodes: any[];
    childrenNodes: any[];
    onNodeClick?: any;
    display?: string;
}

class Tree extends React.Component<TreeProps, any> {
    constructor(props: TreeProps) {
        super(props);

    }

    private _initialize() {
    }

    private _buildTree = (array: any[]): any => {
        var arrayClone = array.slice(0);

        if (arrayClone.length > 0) {
            var item: any = arrayClone.shift();
            var liProps: any = {};
            arrayClone.length == 0 ? liProps.className = "selected" : liProps.onClick = () => this.props.onNodeClick(item);

            var parentName: string = this.props.display ? item[this.props.display] : item;

            return (
                <ul className="parent-category">
                    <li title={parentName}>
                        <span className="glyphicon glyphicon-triangle-bottom"></span>
                        <span {...liProps}>{parentName}</span>
                    </li>
                    {this._buildTree(arrayClone) }
                </ul>
            )
        } else {
            return <TreeChildren onNodeClick={this.props.onNodeClick} childrenNodes={this.props.childrenNodes} display={this.props.display} />
        }
    }

    render() {

        var categories = this._buildTree(this.props.parentNodes);

        return (
            <div className="tree-list">
                {categories}
            </div>
        )
    }
}

interface TreeChildrenProps extends React.PropsWithChildren<{}> {
    childrenNodes: any[];
    onArrowClick?: any;
    onNodeClick?: any;
    display?: any;
}

class TreeChildren extends React.Component<TreeChildrenProps, any> {
    constructor(props: TreeChildrenProps) {
        super(props);

    }

    render() {
        var folderNodes = this.props.childrenNodes.map((node) => {
            var childItem: any = node;
            var childName: string = this.props.display ? childItem[this.props.display] : childItem;

            return (
                <li title={childName} key={node.ID}>
                    <span className="glyphicon glyphicon-triangle-right" onClick={() => console.log(childName) }></span>
                    <span onClick={() => this.props.onNodeClick(childItem) }>{childName}</span>
                </li>
            )
        });

        return (
            <ul className="child-nodes">
                {folderNodes}
            </ul>
        )
    }
}

export default Tree;